import { hydrate } from 'svelte';
import JobsList from './JobsList.svelte';

// Initialize JobsList component
const jobsListEl = document.getElementById('jobs-list');
if (jobsListEl) {
  const companyId = jobsListEl.getAttribute('data-company-id');
  
  if (companyId) {
    hydrate(JobsList, {
      target: jobsListEl,
      props: { companyId }
    });
  } else {
    console.error('Company ID not found for jobs list');
  }
} else {
  console.error('JobsList element not found');
}